import React, { useState } from "react";
import {NavLink} from 'react-router-dom'
import img from "../../view/Hd-Backgrounds.jpg";
import DinImg from '../../view/HD-Wallpapers.jpg'

import "./header.css";

export function Header(){

  const wImg = { width: "100%" };
  const wParafh = { fontSize: "clamp(12.5px, -8px + 5vw, 14px)", color:"darkgray",marginBottom:"3%" }
  const wParafhB = {  padding:"1%", marginLeft:"1.2%", marginRight:"1.2%", fontSize: "clamp(9px, -8px + 5vw, 12.75px)", color:"darkgray" ,border:"0.2px solid darkgray" ,alignItems:"center" , textAlign:"center" }
  const wParafhBP = {fontSize: "clamp(8px, -8px + 5vw, 12px)",marginBottom:"1%" ,color:"aliceblue" , fontWeight:"100",textDecoration: "none"}

  const BoxUndisable= { display:"none" }
  const BoxDisable = { display:"block"  }
  const [ liveBox , setLive ] = useState(false)
  const [ box , setBox ] = useState(BoxUndisable)

  /*
    <div style={{display:"flex"}}>
      <p style= {wParafhBP}>Recientes</p> // Artículos más recientes (3)
      <p style= {wParafhBP}>Leídos</p> //  Artículos más leídos (3)
      <p style= {wParafhBP}>Contexto</p>   Politicas y Avisos legales cookies
    </div> 
  */

 function heandlerChange() {
    if (liveBox === false) {
      setLive(true)
      setBox(BoxDisable)
    } else {
      setLive(false)
      setBox(BoxUndisable)
    }
   
 }
    
  return (
    <header className="container" lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>

      <div style={{display:"flex" ,justifyContent:"space-between" ,paddingLeft:"2%",paddingRight:"2%"}}> 
        <p style= {wParafh}  lang="es">Sitio de dominio y servidor seguro</p>
        <div style={{display:"flex"}}>
          <div>
            <p id="contextTitle" onClick={()=> heandlerChange()} > &#x1F5FA;  </p> 
            <div style={{display:"block"}} >
              <div style={{display:"flex"}}  >
                <div style={box}  className="containerBox">
                  <p><NavLink style= {wParafhBP} to={"/recientes"}>RECIENTES</NavLink></p> 
                  <hr />
                  <p><NavLink style= {wParafhBP} to={"/Avisos-legales"} >AVISOS LEGALES</NavLink> </p>
                </div>
                <div style={box} className="containerBox">
                  <p><NavLink style= {wParafhBP} to={"/leidos"}>MÁS LEIDOS</NavLink></p>
                  <hr />
                  <p><NavLink style= {wParafhBP} to={"/Politicas-de-privacidad"} > PRIVACIDAD </NavLink></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p style= {wParafhB} >Ideas, ciencia y tecnología para descubrir algo nuevo explora nuestros artículos sobre inteligencia artificial, espacio, dispositivos y más.</p>
      <div className="container-class" lang="es">
        <hgroup><h1 id="title" lang="es" >CORONADOS DEL BIEN</h1></hgroup>
        <img style={wImg} src={img} alt="Coronados del bien" loading="eager" decoding="sync"/>
      </div>
    </header>
  );
}

export function Din(){
  const wImg = { width: "100%",height: "50vh" };
  return (
    <header className="container" >
      <div className="container-class" lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
        <hgroup><h1 id="title" lang="es">CORONADOS DEL BIEN</h1></hgroup>
        <img style={wImg} src={DinImg} alt="Coronados del bien"  loading="eager" decoding="sync"/>
      </div>
    </header>
 );
}

export function DinCart(){
  const wImg = { width: "100%",height: "50vh" };
  return (
    <header className="container">
      <div className="container-class" lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
        <hgroup><h1 id="title" lang="es">CORONADOS DEL BIEN</h1></hgroup>
        <img style={wImg} src={DinImg} alt="Coronados del bien"  loading="eager" decoding="sync"/>
      </div>
    </header>
 );
}


export function DinAllow(){
  const wImg = { width: "100%",height: "50vh" };
  return (
    <header className="container" >
      <div className="container-class" lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
        <hgroup><h1 id="title" lang="es" style={{color:"rgba(11, 122, 120, 0.9)"}}>CORONADOS DEL BIEN</h1></hgroup>
        <img style={wImg} id="helpGrey" src={DinImg} alt="Coronados del bien"  loading="eager" decoding="sync"/>
      </div>
    </header>
 );
}

